import { registerPlugins } from '@/plugins'
import App from './App.vue'
import { createApp } from 'vue'
import 'vue3-flag-icons/styles'
const app = createApp(App)
registerPlugins(app)
app.mount('#app')
